import React from "react";
import PropTypes from "prop-types";
import AnimateOnChange from "react-animate-on-change";

class AnimatedText extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        const nextTextValue = nextProps.textValue;
        const oldTextValue = this.props.textValue;

        return nextTextValue !== oldTextValue;
    }

    render() {
        const { textValue, baseClassName, animationClassName } = this.props;
        const shouldAnimate = !!animationClassName;

        return (
            <AnimateOnChange
                baseClassName={ baseClassName }
                animationClassName={ animationClassName }
                animate={ shouldAnimate }
            >
                { textValue }
            </AnimateOnChange>
        );
    }
}

AnimatedText.propTypes = {
    baseClassName: PropTypes.string.isRequired,
    animationClassName: PropTypes.string
};

export default AnimatedText;
